import { route } from '@/ziggy-shim';
import { api, CastValue } from './LaravelClient';

export default {
  async index(projectId: Id, data: ApiRequests['api.v1.purchase-orders.index']) {
    return await api(route('api.v1.purchase-orders.index', { project: projectId }), 'get', {
      data,
      casts: {
        status: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        package_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        search: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async show(id: Id) {
    return await api(route('api.v1.purchase-orders.show', { purchase_order: id }), 'get');
  },

  async create(projectId: Id, data: ApiRequests['api.v1.purchase-orders.store'] | FormData) {
    return await api(route('api.v1.purchase-orders.store', { project: projectId }), 'post', {
      data,
      casts: {
        contractor_ref: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.purchase-orders.update']) {
    return await api(route('api.v1.purchase-orders.update', { purchase_order: id }), 'patch', {
      data,
      casts: {
        contractor_ref: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        package_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async destroy(id: Id) {
    return await api(route('api.v1.purchase-orders.destroy', { purchase_order: id }), 'delete');
  },

  async markPaid(id: Id) {
    return await api(route('api.v1.purchase-orders.mark-paid', { purchase_order: id }), 'post');
  },

  async cancel(id: Id) {
    return await api(route('api.v1.purchase-orders.cancel', { purchase_order: id }), 'post');
  },

  async media(id: Id) {
    return await api(route('api.v1.purchase-orders.media.show', id), 'get');
  },

  async storeMedia(id: Id, data: ApiRequests['api.v1.purchase-orders.media.store'] | FormData) {
    return await api(route('api.v1.purchase-orders.media.store', id), 'post', {
      data,
    });
  },

  async comment(id: Id, data: ApiRequests['api.v1.purchase-orders.comments']) {
    return await api(route('api.v1.purchase-orders.comments', id), 'post', {
      data,
    });
  },
};
